<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Problemas e/ou condições"
    >
        <ListProblemaCondicao
            :data="problemaCondicaoData"
            readonly
        />

        <ListProblemaCondicaoResolvido
            :data="problemaCondicaoResolvidoData"
            readonly
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ListProblemaCondicao from '@/components/ambulatorio/atendimento-enfermagem/components/enfermagem/components/soap/components/avaliacao/components/problema-condicao/List'
import ListProblemaCondicaoResolvido from '@/components/ambulatorio/atendimento-enfermagem/components/enfermagem/components/soap/components/antecedente/components/paciente/components/problema-condicao/List'

export default {
    components: {
        ListProblemaCondicao,
        ListProblemaCondicaoResolvido,
    },
    computed: {
        problemaCondicaoData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.avaliacao,
                model: this.data.model.avaliacao,
            }
        },
        problemaCondicaoResolvidoData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.antecedentes,
                model: this.data.model.antecedentes,
            }
        },
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>